export class autoComplete{
    SearchText:string;
    TableName: string;
}